<template>
    <div>
        <adminUserGroupList ></adminUserGroupList>
    </div>
</template>
<script>

import adminUserGroupList from '@/components/admin/user_group/list.vue';

export default {
    components: {
        adminUserGroupList
    },
    data () {
        let self = (window.x = this)
        return {
        }
    },
    methods: {
        demo () {
        },
        // end 
    },
    mounted () {
        // this.getData()
    },
    watch: {},
    computed: {}
}
</script>
